import { render, staticRenderFns } from "./realisasi_fisik_keuangan.vue?vue&type=template&id=4b1576be&scoped=true&"
import script from "./realisasi_fisik_keuangan.vue?vue&type=script&lang=js&"
export * from "./realisasi_fisik_keuangan.vue?vue&type=script&lang=js&"
import style0 from "./realisasi_fisik_keuangan.vue?vue&type=style&index=0&id=4b1576be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1576be",
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
